import { render, staticRenderFns } from "./UploadImgWidget.vue?vue&type=template&id=c7fa4e4e&scoped=true"
import script from "./UploadImgWidget.vue?vue&type=script&lang=js"
export * from "./UploadImgWidget.vue?vue&type=script&lang=js"
import style0 from "./UploadImgWidget.vue?vue&type=style&index=0&id=c7fa4e4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fa4e4e",
  null
  
)

export default component.exports